import React from "react"
import { Box, useTheme, SxProps } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

import { SearchToggleButton } from "components/domains/search/SearchToggleButton"
import { SearchIcon as DefaultSearchIcon } from "components/icons"
import { LanguageButton } from "extensions/iconsiam/components/language/LanguageButton"
import { useAppUI } from "providers/ui"

export interface ISidebarMenuProps {
  sx?: SxProps
  AppNavigation?: () => JSX.Element
}

export const SidebarMenu: React.FC<ISidebarMenuProps> = ({
  sx = {},
  AppNavigation,
}) => {
  const { openSearch } = useAppUI()
  const { t } = useTranslation()
  const theme = useTheme()

  const {
    root,
    navigationContainer,
    toolbarContainer,
    actionButton,
    headerContainer,
    headerLogo,
  } = theme.components[`SidebarMenu`]?.styleOverrides || {}

  return (
    <Box sx={deepmerge(root, sx)}>
      {/* Header */}
      <Box sx={headerContainer}>
        <Box sx={headerLogo}></Box>
      </Box>
      {/* Navigation */}
      <Box sx={navigationContainer}>{AppNavigation && <AppNavigation />}</Box>
      {/* Toolbar */}
      <Box sx={toolbarContainer}>
        <SearchToggleButton
          icon={DefaultSearchIcon}
          sx={actionButton}
          placeholder={t("Search...")}
          onClick={openSearch}
        />
        <LanguageButton sx={actionButton} />
      </Box>
    </Box>
  )
}
